import $axios from "@/plugins/axios";
import { Decrypt } from "@/js/encryp.js";
const home = {
    //查首页banner
    banners: params => $axios.get('PC/Home/GetADList', params),
    getPageForHome: params => $axios.post('PC/Home/GetPageForHome', params),
    getTaskList: params => $axios.post('PC/Home/GetTaskList', params),
    getQuestionPackageList: params => $axios.post3('PC/Home/GetQuestionPackageList', params),
    // //banners: params => $axios.get(`/Home/banners`, params),
    // //栏目列表
    // columns: params => $axios.get(Decrypt(`4wGpwsimStUaji5P8GNoYw==`), params),
    // //推荐课程TABS
    // CoursesTabs: params => $axios.get(Decrypt(`QkWQIrfUUNgRTx3z+SwDruYcpgzhGcbtBQp33UwJMBA=`), params),
    // //首页最新教参
    // new: params => $axios.get(Decrypt(`pWEya9ynhrtMZQUOMcJbLw==`), params),
    // //查推荐课程
    // recommendCourses: params => $axios.get(Decrypt(`QkWQIrfUUNgRTx3z+SwDrnh3oKJOqRB54Vsm0bZ1AKc=`), params),

    // //推荐教参TAB 
    // BookTabs: params => $axios.get(Decrypt(`+OJ9EV/Mh/dkfrFVZBX0asvmowJzEFkuPQtDEK+3Mrg=`), params),
    // //推荐教参
    // recommendBook: params => $axios.get(Decrypt(`+OJ9EV/Mh/dkfrFVZBX0akFG6mKOsaSlV8t0kk8h9no=`), params),
    // //查最新课程更多
    // newCourses: params => $axios.get(Decrypt(`lDxERLWzJwySFOQYHguh2/yD4XVcvCQNZT3WTjKGMb8=`), params),
    // //查最新教参更多
    // newBook: params => $axios.get(Decrypt(`Tjv6bvhpr3wKsbDxAYwG+A==`), params),
    // //通过父级获取子级
    // getColumnListByParent: params => $axios.get(Decrypt(`0Dh+LOQsJe7Tqfgi30XZRePQTJ4luajGFDF0zPyrpBc=`), params),
    // //通过父级获取子级
    // getNextColumn: params => $axios.get(Decrypt(`9DzijFJxyTelUmawm0CLwcuoigEXR+FwjTkYpDb5nyc=`), params),
    // //通过栏目取书籍
    // getBookByColumn: params => $axios.get(Decrypt(`MT8w7Rb0FtkGB0HpcrTJpAsWzyWWM+eIcaWHnQVYbfw=`), params),
    // //根据ID获取栏目对象
    // getColumnById: params => $axios.get(Decrypt(`eiHqK57ScRM3ot9Y+tyfg0c+6hP+NJPi0MyOqz8DrdQ=`), params),
}
export default home;